import * as React from 'react'
import { IconPropsType } from '../types'

const GoogleEarthIcon = (props: IconPropsType): React.ReactElement => {
   const { width = 17, height = 16 } = props

   return (
      <svg
         xmlns='http://www.w3.org/2000/svg'
         width={width}
         height={height}
         viewBox='0 0 17 16'
         fill='none'
      >
         <path
            d='M6.01728 9.66715C3.29001 6.05964 0.490013 8.80095 1.22092 11.3223C3.05938 15.3425 7.80936 17.1114 11.8303 15.2733C13.2162 14.6397 14.3925 13.6237 15.2209 12.3448C13.1127 14.319 9.28455 13.9891 6.01728 9.66715Z'
            fill='#255FDB'
         />
         <path
            d='M8.45546 7.18307C4.70455 1.49503 0.500013 4.52629 0.500013 8.0011C0.498496 9.15191 0.746623 10.2894 1.22728 11.335C0.728194 8.98 3.43456 7.16398 5.95455 10.5443C9.61364 15.4524 13.2045 14.589 15.2136 12.3557C15.8589 11.3654 16.2756 10.244 16.4336 9.07271V9.08817C15.5709 11.764 11.7636 12.1994 8.45546 7.18307Z'
            fill='#4285F4'
         />
         <path
            d='M11.0264 4.63808C8.24092 0.0434852 4.7091 0.457043 2.31819 2.91931C1.13962 4.35037 0.496696 6.14734 0.500013 8.0011C0.750014 4.63809 4.81819 2.29761 8.50001 8.0011C11.7727 13.0774 15.85 11.7549 16.43 9.10271V9.07726C16.4808 8.71602 16.5023 8.35127 16.4945 7.98656V7.62299C15.0773 8.63734 13.2136 8.24559 11.0264 4.63808Z'
            fill='#91BFFF'
         />
         <path
            d='M11.0455 5.45612C13.5964 9.55626 15.7955 8.50737 16.5 7.63026C16.4715 7.01738 16.3724 6.40983 16.2045 5.81969C15.0155 5.84423 14.7382 5.64608 13.5682 3.86459C11.78 1.1251 9.52728 -0.724555 5.59092 0.547935C4.31554 1.04807 3.18903 1.86557 2.31819 2.92295C5.02273 0.434321 8.34091 1.10965 11.0455 5.45612Z'
            fill='#C4E1FF'
         />
         <path
            d='M13.3936 4.21726C14.56 6.00147 15.27 6.09236 16.2045 5.81969C14.9928 1.5643 10.5602 -0.903267 6.30404 0.308235C6.06271 0.376926 5.82474 0.456914 5.59092 0.547935C9.10728 -0.560952 11.6009 1.47685 13.3936 4.21726Z'
            fill='#F5F5F5'
         />
         <path
            d='M8.50001 15.9996C12.9183 15.9996 16.5 12.4186 16.5 8.0011C16.5 3.58364 12.9183 0.00258356 8.50001 0.00258356C4.08173 0.00258356 0.500013 3.58364 0.500013 8.0011C0.500013 12.4186 4.08173 15.9996 8.50001 15.9996Z'
            fill='url(#paint0_radial_36868_1508)'
            fill-opacity='0.1'
         />
         <path
            d='M8.50001 0.0934767C12.9005 0.0934767 16.475 3.64682 16.5 8.04654V8.0011C16.5 3.58364 12.9183 0.00258356 8.50001 0.00258356C4.08173 0.00258356 0.500013 3.58364 0.500013 8.0011V8.04654C0.52501 3.64682 4.09946 0.0934767 8.50001 0.0934767Z'
            fill='white'
            fill-opacity='0.2'
         />
         <path
            d='M8.50001 15.9087C4.09946 15.9087 0.525013 12.3554 0.500013 7.95565V8.0011C0.500013 12.4186 4.08173 15.9996 8.50001 15.9996C12.9183 15.9996 16.5 12.4186 16.5 8.0011V7.95565C16.475 12.3554 12.9005 15.9087 8.50001 15.9087Z'
            fill='#1A237E'
            fill-opacity='0.2'
         />
         <defs>
            <radialGradient
               id='paint0_radial_36868_1508'
               cx='0'
               cy='0'
               r='1'
               gradientUnits='userSpaceOnUse'
               gradientTransform='translate(2.91632 2.41641) scale(15.8945)'
            >
               <stop stop-color='white' />
               <stop offset='1' stop-color='white' stop-opacity='0' />
            </radialGradient>
         </defs>
      </svg>
   )
}

export default GoogleEarthIcon
